"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _content = babelHelpers.interopRequireDefault(require("./content"));

var _decorators = require("decorators");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _temp;

var VideoActivity = (_class = (_temp =
/*#__PURE__*/
function (_ContentActivity) {
  babelHelpers.inherits(VideoActivity, _ContentActivity);

  function VideoActivity() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, VideoActivity);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(VideoActivity)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this.currentPosition = 0;
    _this.prevPosition = 0;
    _this.serverPosition = NaN;
    babelHelpers.initializerDefineProperty(_this, "playerElement", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "player", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "options", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "videoLength", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "clientPosition", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "start", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.trackTimeout = null;
    babelHelpers.initializerDefineProperty(_this, "eventListener", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.didEndActivity = false;
    _this.handlePlay = true;
    _this.pbi = null;
    _this.ended = false;
    return _this;
  }

  babelHelpers.createClass(VideoActivity, [{
    key: "setup",
    value: function setup(_ref, options) {
      var messageServer = _ref.messageServer,
          customerKey = _ref.customerKey,
          app = _ref.app,
          object = _ref.object,
          sessionID = _ref.sessionID;
      this.messageServer = messageServer;
      this.customerKey = customerKey;
      this.app = app;
      this.object = object;
      this.sessionID = sessionID;
      this.eventListener.start();
      this.resourceOptions = options;

      if (options && options.transcript) {
        this.$('.section-item.item-content').addClass('has-transcript');
      }

      this.on('unload', this.videoUnload);
      this.player.on('timeupdate', this.playerTimeupdate);
      this.player.on('play', this.playerPlay);
      this.player.on('pause', this.playerPause);
      this.player.on('stop', this.playerStop);
      this.player.on('ended', this.playerEnded);
      this.stopTimer();
    }
  }, {
    key: "playerEnded",
    value: function playerEnded(event) {
      this.ended = true;
    }
  }, {
    key: "playerStop",
    value: function playerStop(event) {
      this.playerPause(event);
    }
  }, {
    key: "playerPause",
    value: function playerPause(event) {
      if (this.pbi) {
        clearInterval(this.pbi);
        this.pbi = null;
      }

      try {
        var t;

        if (babelHelpers.instanceof(this.player.core.containers[0].playback, Clappr.FlasHLS)) {
          t = this.player.core.containers[0].playback.el.getPosition();
        } else {
          t = this.playerElement.find('audio, video')[0].currentTIme;
        }

        this.clientPosition = Math.max(this.clientPosition, t);
        this.updatePosition();
        this.handlePlay = true;
      } catch (e) {
        ;
      }
    }
  }, {
    key: "getHLSClientPosition",
    value: function getHLSClientPosition() {
      this.clientPosition = Math.max(this.clientPosition, this.player.core.containers[0].playback.el.getPosition());
      this.updatePosition();
    }
  }, {
    key: "playerPlay",
    value: function playerPlay() {
      if (babelHelpers.instanceof(this.player.core.containers[0].playback, Clappr.FlasHLS)) {
        clearInterval(this.pbi);
        this.pbi = setInterval(this.getHLSClientPosition, 50);
      }

      if (this.ended) return;

      if (this.handlePlay && this.clientPosition !== 0) {
        try {
          this.playerElement.find('audio, video')[0].currentTime = this.clientPosition;
          this.handlePlay = false;
        } catch (e) {}
      }
    }
  }, {
    key: "playerTimeupdate",
    value: function playerTimeupdate(event) {
      if (event.current === event.total && event.current === 1) {
        try {
          var e = this.playerElement.find('audio, video')[0].currentTime;
          this.clientPosition = Math.max(this.clientPosition, e);
        } catch (e) {}
      } else {
        this.clientPosition = Math.max(this.clientPosition, event.current);
      }

      this.updatePosition();
    }
  }, {
    key: "playerUnload",
    value: function playerUnload() {
      this.eventListener.close();
    }
  }, {
    key: "handleMessage",
    value: function handleMessage(_ref2) {
      var type = _ref2.type,
          data = _ref2.data;

      if (type == 'progress') {
        var _JSON$parse = JSON.parse(data),
            position = _JSON$parse.progress.position;

        this.serverPosition = position;
        this.updatePosition();
      }

      if (type == 'finished') {
        if (!this.didEndActivity) {
          this.didEndActivity = true;
          this.endActivity();
        }
      }
    }
  }, {
    key: "executeTracking",
    value: function executeTracking() {
      var app = this.app,
          object = this.object,
          currentPosition = this.currentPosition,
          prevPosition = this.prevPosition,
          videoLength = this.videoLength,
          start = this.start;
      var opts = {
        app: app,
        object: object,
        currentPosition: currentPosition,
        length: videoLength,
        startedPlayback: start
      };
      if (Math.abs(currentPosition - videoLength) < 5) opts.currentPosition = currentPosition = videoLength;

      if (prevPosition != currentPosition) {
        var e = encodeURIComponent;
        $.get("hls-track?".concat(Object.keys(opts).map(function (k) {
          return "".concat(e(k), "=").concat(e(String(opts[k])));
        }).join('&')), function () {});
      }

      this.prevPosition = currentPosition;
      clearTimeout(this.trackTimeout);
      this.trackTimeout = null;
      window.removeEventListener('focus', this.executeTracking);
    }
  }, {
    key: "doTrack",
    value: function doTrack() {
      if (this.trackTimeout) return;
      this.trackTimeout = setTimeout(this.executeTracking, 2000);
      window.addEventListener('focus', this.executeTracking);
    }
  }, {
    key: "updatePosition",
    value: function updatePosition() {
      if (isNaN(this.serverPosition)) this.currentPosition = isNaN(this.clientPosition) ? 0 : this.clientPosition;else this.currentPosition = isNaN(this.clientPosition) ? this.serverPosition : Math.min(this.clientPosition, this.serverPosition);
      this.doTrack();
    }
  }]);
  return VideoActivity;
}(_content.default), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "playerElement", [_decorators.memoize], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return $('#video-player');
  }
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "player", [_decorators.memoize], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.playerElement.data('player');
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "options", [_decorators.memoize], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.player.options;
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "videoLength", [_decorators.memoize], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.options.videoDuration;
  }
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "clientPosition", [_decorators.memoize], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.options.videoPlaybackFinished ? 0 : 'startPosition' in this.options ? this.options.startPosition : NaN;
  }
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "start", [_decorators.memoize], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return Date.now();
  }
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "eventListener", [_decorators.memoize], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return Object.assign(new EventSourceImpl("".concat(this.messageServer, "/").concat(this.customerKey, "/hls-").concat(this.sessionID, "-").concat(this.app, "-").concat(this.object)), {
      onmessage: this.handleMessage
    });
  }
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "playerEnded", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "playerEnded"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "playerStop", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "playerStop"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "playerPause", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "playerPause"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "getHLSClientPosition", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "getHLSClientPosition"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "playerPlay", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "playerPlay"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "playerTimeupdate", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "playerTimeupdate"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "playerUnload", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "playerUnload"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "handleMessage", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "handleMessage"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "executeTracking", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "executeTracking"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "doTrack", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "doTrack"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "updatePosition", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "updatePosition"), _class.prototype)), _class);
exports.default = VideoActivity;